import React from "react";
import Accordion from "@mui/material/Accordion";
import {COLORS} from "../../../../../../../config/constants";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';
import AccordionDetails from "@mui/material/AccordionDetails";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

import {CertificationType} from "../../index";
import {useCalculationReadOnly} from '../../../../calculation-read-only';

type Props = {
  title: React.ReactNode
  value: CertificationType
  children: React.ReactNode
  isExpanded: boolean
  isActive: boolean
  handleChangeAccordion: (value: boolean) => void
}

const RadioTemplate = ({ title, value, isExpanded, handleChangeAccordion, children, isActive } : Props) => {

  const readOnly = useCalculationReadOnly();

  const handleChange = (event: React.SyntheticEvent, expanded: boolean) => {
    handleChangeAccordion(expanded);
    event.preventDefault();
  };

  const handleSummaryClick = (event: React.MouseEvent) => {
    if (!readOnly) {
      return;
    }

    const target = event.target as HTMLElement;

    if (target.closest('.MuiRadio-root, .MuiFormControlLabel-root')) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return <Accordion
    sx={{
      boxShadow: "none",
      border: isActive
        ? `2px solid ${COLORS.BLUE}`
        : `1px solid ${COLORS.SLIGHTLY_GRAY}`,
      marginBottom: 0,
      '&:before': {
        backgroundColor: 'transparent',
      },
      '&.Mui-expanded': {
        margin: 0,
      }
    }}
    className='certification-radio'
    expanded={isExpanded}
    onChange={handleChange}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon style={{
        width: '24px',
        height: '24px',
        color: COLORS.LIGHT_ACTION,
      }} />}
      sx={{
        padding: '24px',
        minHeight: '74px',
        '&.Mui-expanded': {
          minHeight: '74px',
          paddingBottom: '23px',
        },
        '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
          margin: 0,
          minWidth: 0,
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
          marginLeft: '16px',
        },
      }}
      onClick={handleSummaryClick}
    >
      <FormControlLabel
        value={value}
        control={<Radio disabled={readOnly} sx={{
          padding: 0,
          marginTop: '1px',
          flexShrink: 0,
        }} />}
        disabled={readOnly}
        sx={{
          margin: 0,
          width: '100%',
          minWidth: 0,
          alignItems: 'flex-start',
          '& .MuiFormControlLabel-label': {
            flex: 1,
            minWidth: 0,
          },
        }}
        label={title} />
    </AccordionSummary>
    <AccordionDetails sx={{ padding: '24px' }}>
      {children}
    </AccordionDetails>
  </Accordion>
}

export default RadioTemplate
